import React, { useEffect, useState, useRef, useCallback, use } from "react";
import { CircularProgress } from "@mui/material";
import { useShowAlert } from "../../../../context/AlertContext";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../../context/AuthProvider";
import { useNetwork } from "../../../../context/NetworkContext";
import { usePermission } from "../../../../context/PermissionContext";
import { useContextApi } from "../../../../context/ContextApi";
import Thermal_1 from "./thermal_printer_temps/Thermal_1";
import Thermal_2 from "./thermal_printer_temps/Thermal_2";
import { CheckIcon, ReceiptIcon, XIcon } from "../../../../constants/Icons";

const ThermalTempPreview = ({
  isData,
  onClose,
  onDataUpdate,
  onDataChange,
  onListSaleRefresh,
  onAdd,

  halfA4Theme="HA4RET",
  invoiceTheme = "INVPRO",
  termalTheme = "TMLBAS",

  viewTheme,
}) => {
  const { permission, blockedPermissions, storeSettings, viewOption } =
    usePermission();
  const [selectedOption, setSelectedOption] = useState(invoiceTheme);
  const [selectTermalOption, setSelectTermalOption] = useState(termalTheme);
  const [selectHalfA4Option, setSelectHalfA4Option] = useState(halfA4Theme);
  const [selectViewOption, setSelectedViewOption] = useState(viewTheme);
  const [selectedTheme, setSelectedTheme] = useState({
    key: "DF",
    templateTheme: {
      primaryColor: "#f4f4f6",
      secondaryColor: "#ffffff",
      foregroundColor: "#242c6d",
      backgroundColor: "#f4f4f6",
      borderColor: "#c9c9d1",
    },
  });
  const { useEscapeKey } = useContextApi();
  const [isBtnLoading, setBtnLoading] = useState(false);
  const [isMainModalOpen, setIsMainModalOpen] = useState(true);
  const [data, setData] = useState({});
  const navigate = useNavigate();
  const [showConfirm, setShowConfirm] = useState(false);
  const [selectedSize, setSelectedSize] = useState("INVOICE");

  const sizeOptions = [
    { key: "BILL", label: "BILL" },
    { key: "INVOICE", label: "INVOICE" },
  ];

  const handleRadioTermal = (option, color) => {
    setSelectTermalOption(option);
    setSelectedViewOption(option);
    console.log("terradio");
  };

  const handleClose = () => {
    setIsMainModalOpen(false);
    onClose();
  };
  useEscapeKey(handleClose);

  const handleSelectTemp = () => {
    onAdd(selectedOption, selectTermalOption,selectHalfA4Option, selectedTheme?.templateTheme);
  };

  useEffect(() => {
    if (storeSettings.invoiceSettings?.template?.templateTheme) {
      setSelectedTheme(storeSettings.invoiceSettings?.template);
    }
    setSelectedOption(invoiceTheme);
    setSelectTermalOption(termalTheme);
    setSelectHalfA4Option(halfA4Theme)
    setSelectedViewOption(viewTheme);
  }, []);

  const handleModeConfirm = () => {
    setShowConfirm(true);
  };

  useEffect(() => {
    setSelectedSize("INVOICE");
  }, []);

  useEffect(() => {
    setData(isData);
  }, [isData]);

  return (
    <>
      {isMainModalOpen && (
        <div>
          <div className="modal-backdrop show"></div>
          <div
            className="modal show"
            id="CustomerModal"
            tabIndex="-1"
            aria-modal="true"
            role="dialog"
            style={{ display: "block" }}
          >
            <div className="modal-dialog modal-dialog-scrollable modal-md">
              <div className="modal-content">
                <div className="modal-header">
                  <div className="d-flex align-items-center">
                    <h6 className="modal-title mb-0">Template - {selectTermalOption==="TMLBAS"&&("Basic Thermal")}
                  {selectTermalOption==="TMLMOD"&&("Modern Thermal")}</h6>
                    {viewOption("saleModeSettings", "isInvoice") &&
                      data.salemode === "BILL" &&
                      data.status === "ACTIVE" &&
                      (isBtnLoading ? (
                        <button
                          className="btn bg-label-network pb-0 text-right ms-3"
                          disabled
                        >
                          <CircularProgress size={22} className="text-white" />
                        </button>
                      ) : (
                        <button
                          className="btn bg-label-network shadow-none text-right ms-3"
                          onClick={handleModeConfirm}
                        >
                          <ReceiptIcon/> Convert To Invoice
                        </button>
                      ))}
                  </div>

                  <div className="d-flex align-items-center gap-2">
                    <p className="mb-0 ">Sample Thermal</p>

                    <button
                      type="button"
                      onClick={handleClose}
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                </div>
                <div
                  className="modal-body p-0 d-flex"
                  // style={{ height: "100%" }}
                  style={{ height: "80vh", overflow: "hidden" }}
                  id="element-to-download"
                >
                  <div
                    className="px-3 py-1 flex-grow-1 hide-scrollbar"
                    style={{
                      overflowY: "auto",
                      maxHeight: "100%",
                    }}
                  >
                    {selectTermalOption === "TMLBAS" && (
                      <Thermal_1
                        isViewData={data}
                        selectedSize={selectedSize}
                        selectedTheme={selectedTheme}
                        downloadbtn={true}
                      />
                    )}
                    {selectViewOption === "TMLMOD" && (
                      <Thermal_2
                        isViewData={data}
                        selectedSize={selectedSize}
                        selectedTheme={selectedTheme}
                        downloadbtn={true}
                      />
                    )} 
                  </div>
                  <div
                    className="border-start"
                    style={{
                      width: "170px",
                      flex: "0 0 170px",
                      overflowY: "auto",
                    }}
                  >
                    <div>
                      <span className="px-2 breadcrumb-title">
                        Thermal Printer
                      </span>
                      <div className="invoice-thumbnailModel-grid mt-2 p-1">
                        <div
                          className={`thermal-thumbnailModel position-relative form-check custom-option custom-option-image custom-option-image-check
              ${
                selectTermalOption === "TMLBAS" ? "active" : ""
              } ms-2 mb-1 cursor-poInter`}
                          onClick={() =>
                            handleRadioTermal(
                              "TMLBAS",
                              selectedTheme?.templateTheme
                            )
                          }
                        >
                          {/* <input
                            name="customRadioImage"
                            className="form-check-input bg-label-dark-blue cursor-poInter"
                            type="checkbox"
                            id={"TMLBAS"}
                            checked={selectTermalOption === "TMLBAS"}
                            onChange={() =>
                              handleRadioTermal(
                                "TMLBAS",
                                selectedTheme?.templateTheme
                              )
                            }
                            style={{
                              top: "175px",
                              left: "8px",
                              borderRadius: "50%",
                              width: "30px",
                              height: "30px",
                              transform: "translateY(-50%)",
                              zIndex: 2,
                            }}
                          /> */}
                          <div className="template-label">
                          Basic Thermal 
                          </div>
                          <div
                            className="invoice-Thermalscale"
                            for={"TMLBAS"}
                            onClick={() => {
                              setSelectTermalOption("TMLBAS");
                              setSelectedViewOption("TMLBAS");
                            }}
                          >
                            <Thermal_1
                              isViewData={data}
                              selectedTheme={selectedTheme}
                              selectedSize={"INVOICE"}
                              width={false}
                            />
                          </div>
                        </div>
                        
                        <div
                          className={`thermal-thumbnailModel position-relative form-check custom-option custom-option-image custom-option-image-check
              ${
                selectTermalOption === "TMLMOD" ? "active" : ""
              } ms-2 mb-1 cursor-poInter`}
                          onClick={() =>
                            handleRadioTermal(
                              "TMLMOD",
                              selectedTheme?.templateTheme
                            )
                          }
                        >
                          {/* <input
                            name="customRadioImage"
                            className="form-check-input bg-label-dark-blue cursor-poInter"
                            type="checkbox"
                            id={"TMLBAS"}
                            checked={selectTermalOption === "TMLBAS"}
                            onChange={() =>
                              handleRadioTermal(
                                "TMLBAS",
                                selectedTheme?.templateTheme
                              )
                            }
                            style={{
                              top: "175px",
                              left: "8px",
                              borderRadius: "50%",
                              width: "30px",
                              height: "30px",
                              transform: "translateY(-50%)",
                              zIndex: 2,
                            }}
                          /> */}
                          <div className="template-label">
                          Modern Thermal
                          </div>
                          <div
                            className="invoice-Thermalscale"
                            for={"TMLMOD"}
                            onClick={() => {
                              setSelectTermalOption("TMLMOD");
                              setSelectedViewOption("TMLMOD");
                            }}
                          >
                            <Thermal_2
                              isViewData={data}
                              selectedTheme={selectedTheme}
                              selectedSize={"INVOICE"}
                              width={false}
                            />
                          </div>
                        </div>
                        
                      </div>
                    </div>
                  </div>
                </div>

                <div className="modal-footer d-block">
                  <button
                    onClick={handleClose}
                    type="button"
                    data-bs-dismiss="modal"
                    className="btn btn-outline-secondary text-start"
                  >
                    <XIcon iClass={"fs-15"}/> Close
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary text-right "
                    onClick={handleSelectTemp}
                  >
                    <CheckIcon/>Apply
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ThermalTempPreview;
